import type { HTMLImgProps } from '../../types'

export enum IllustrationSize {
  small = 's',
  medium = 'm',
  large = 'l',
  xlarge = 'xl',
  xxlarge = 'xxl',
}

export type IllustrationSizeType = `${IllustrationSize}`

interface IllustrationPropsBase {
  className?: string
  size?: IllustrationSizeType
}

export type IllustrationProps = IllustrationPropsBase & HTMLImgProps
